/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-28",
    versionChannel: "nightly",
    buildDate: "2025-05-28T00:07:06.571Z",
    commitHash: "dbb6ef1e6a792949d3020e5e562a4f898b30eca4",
};
